import * as types from './types';

export default {
    [types.MUTATE_UPDATE_ZIPCODE]: (state, payload) => {
        //Update zipcode
        state.zipcode = payload;
    },
    [types.MUTATE_UPDATE_CONTAINER_LIST]: (state, payload) => {
        //Assign lowest priced containers within the delivery-zone
        state.containers_list = payload;
    },
    [types.MUTATE_UPDATE_CART_LIST]: (state, payload) => {
        //Add items to the cart
        state.containerdetailes.push(payload);
    },
    [types.MUTATE_UPDATE_CART_CUSTOMATTRIBUTE]: (state, payload) => {
        //Update line item's custom attibute in the cart        
        state.containerdetailes[parseInt(payload.itemindex)]["customAttributes"] = payload["customAttributes"];
    },
    [types.MUTATE_UPDATE_CART_CSCSURVEY]: (state, payload) => {
        //Update line item's CSC SURVEYE attribute in the cart
        state.containerdetailes[payload]["CSCSurvey"] = state.CSCSurvey;
    },
    [types.MUTATE_DELETE_CART_CSCSURVEY]: (state, payload) => {
        //Delete line item's CSC SURVEYE attribute in the cart
        delete state.containerdetailes[payload]["CSCSurvey"];
    },
    [types.MUTATE_REMOVE_CARTITEM]: (state, payload) => {
        //Remove cart's line item
        state.containerdetailes.splice(payload, 1)
    },
    [types.MUTATE_UPDATE_RESETCART]: (state) => {
        //Reset the cart
        state.containerdetailes = [];
    },
    [types.MUTATE_UPDATE_TYPE]: (state, payload) => {
        state.type = payload;
    },
    [types.MUTATE_UPDATE_PURPOSE]: (state, payload) => {
        state.purpose = payload;
    },
    [types.MUTATE_UPDATE_DELIVERY]: (state, payload) => {
        state.delivery = payload;
    },
    [types.MUTATE_UPDATE_CSC_TERMS]: (state, payload) => {
        state.cscterms = payload;
    },
    [types.MUTATE_UPDATE_CSC_SURVEY]: (state, payload) => {
        state.CSCSurvey = payload;
    },
    [types.MUTATE_UPDATE_CURRENTSURVEYOBJECT]: (state, payload) => {
        state.currentSurveyObject = payload;
    },
    [types.MUTATE_UPDATE_CURRENTSURVEY_PURPOSE]: (state, payload) => {
        state.currentSurveyObject.purpose = payload;
    },
    [types.MUTATE_UPDATE_CURRENTSURVEY_TYPE]: (state, payload) => {
        state.currentSurveyObject.type = payload;
    },
    [types.MUTATE_UPDATE_TERMSCHECKBOX]: (state, payload) => {
        state.termsCheckbox = payload;
    },
    [types.MUTATE_UPDATE_LINEITEMHAULERPRICE]: (state, payload) => {
        state.lineItemHaulerPrice = payload;
    },
    [types.ACTIONS_UPDATE_LINEITEMMARKET]: (state, payload) => {
        state.lineItemMarket = payload;
    },
    [types.MUTATE_UPDATE_PREDELIVERYANSWERS]: (state, payload) => {
        state.predelivery = payload;
    },
    [types.MUTATE_UPDATE_DELIVERY_DOORDIRECTION]: (state, payload) => {
        state.predelivery.doordirection = payload;
    },
    [types.MUTATE_UPDATE_DELIVERY_SPACE]: (state, payload) => {
        state.predelivery.deliveryspace = payload;
    },
    [types.MUTATE_UPDATE_DELIVERY_RUSTACKNOWLEDGE]: (state, payload) => {
        state.predelivery.rustacknowledge = payload;
    },
    [types.MUTATE_UPDATE_DELIVERY_INSTRUCTIONS]: (state, payload) => {
        state.predelivery.deliveryinstructions = payload;
    },
    [types.MUTATE_UPDATE_DELIVERY_NAME]: (state, payload) => {
        state.predelivery.deliveryname = payload;
    },
    [types.MUTATE_UPDATE_DELIVERY_PHONE]: (state, payload) => {
        state.predelivery.deliveryphone = payload;
    },    
    [types.MUTATE_UPDATE_DELIVERY_NONACCEPTABLEDATES]: (state, payload) => {
        state.predelivery.nonacceptabledates = payload;
    },
    [types.MUTATE_UPDATE_DELIVERY_SURFACETYPE]: (state, payload) => {
        state.predelivery.deliverysurfacetype = payload;
    },
    [types.MUTATE_UPDATE_DELIVERY_SOFTSURFACEACKNOWLEDGE]: (state, payload) => {
        state.predelivery.softSurfaceAcknowledge = payload;
    },
    [types.MUTATE_UPDATE_PREPICKUPANSWERS]: (state, payload) => {
        state.prepickup = payload;
    },
    [types.MUTATE_UPDATE_PICKUP_RUSTACKNOWLEDGE]: (state, payload) => {
        state.prepickup.rustacknowledge = payload;
    },
    [types.MUTATE_UPDATE_PICKUP_INSPECTION]: (state, payload) => {
        state.prepickup.inspection = payload;
    },
    [types.MUTATE_UPDATE_PICKUP_INSTRUCTIONS]: (state, payload) => {
        state.prepickup.pickupinstructions = payload;
    },
    [types.MUTATE_UPDATE_PICKUP_NAME]: (state, payload) => {
        state.prepickup.pickupname = payload;
    },
    [types.MUTATE_UPDATE_FEEDBACKGIVEN]: (state, payload) => {
        state.feedbackGiven = payload;
    },
    [types.MUTATE_UPDATE_COUNTRYCODE]: (state, payload) => {
        state.country_code = payload;
    },
};